import { actionCreators, identity } from '../../../ducks/actions';
import { Confirmation } from './state';

export const confirmationActions = actionCreators(
  {
    cancel: identity<Confirmation>(),
  },
  'confirmations'
);
